import Header from "./Components/Header";
import 'react-toastify/dist/ReactToastify.css';
import { useEffect, useState } from "react";
import LandingPage from "./Components/LandingPage";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { UserProvider } from './Context';
import AddLease from "./Components/AddLease";
import SignUp from "./Components/SignUp";
import SignIn from "./Components/SignIn";
import Dashboard from "./Components/Dashboard";
import AdminDashboard from "./Components/AdminDashboard";
import AmmortizationSchedule from "./Components/AmmortizationSchedule";
import Reports from "./Components/Reports";
import Feedback from "./Components/Feedback";
import ErrorPage from "./Components/ErrorPage";

function App() {
  const router = createBrowserRouter([
    {
      path: "/", element: <Header />, children: [
        { index:true, element: <LandingPage /> },
        {path: 'dashboard', element: <Dashboard />},
        {path:"add-lease",element:<AddLease/>},
        {path:'sign-up', element:<SignUp/>},
        {path:'sign-in', element:<SignIn/>},
        {path:'ammortization-schedule', element:<AmmortizationSchedule/>},
        {path:'admin-dashboard',element:<AdminDashboard/>},
        {path:'reports',element:<Reports/>},
        {path:'feedback',element:<Feedback/>},
      ],
      errorElement: <ErrorPage/>,
    },
  ]);

  return (
    <>
      <UserProvider>
        <RouterProvider router={router} />
      </UserProvider>
    </>
  );
}

export default App;
